<template>
    <div class="item">
        <!-- 账号、重置密码 和 编辑 删除按钮 -->
        <div class="item-header">
            <div class="item-header-number">
                <span>单位账号：{{ unitObj.mobile }}</span>
                <button @click="resetPassword">重置密码</button>
            </div>
            <div class="item-header-btn">
                <button @click="editUnit" class="edit"><img src="../../../assets/iconFolder/common/common_edit_icon.png" alt=""></button>
                <button @click="deleteUnit" class="delete"><img src="../../../assets/iconFolder/common/common_delete_icon.png" alt=""></button>
            </div>
        </div>
        <!-- 单位名称 -->
        <el-tooltip popper-class="tool-tip-class" placement="bottom-start" effect="light" :visible-arrow="false">
            <div slot="content">{{ unitObj.deptName }}<br/>负责人：{{ unitObj.username }}<br/>联系方式：{{ unitObj.mobile }}</div>
            <h4>{{ unitObj.deptName }}</h4>
        </el-tooltip>
        <!-- 下面的任务数量和施工队数量 -->
        <div class="item-count">
            <div>
                <img src="../../../assets/iconFolder/common/common_unit_task.png" alt="">
                <span>钻探任务数量：{{ unitObj.zkCount }} 个</span>
            </div>
            <div>
                <img src="../../../assets/iconFolder/common/common_unit_icon.png" alt="">
                <span>施工队数量：{{ unitObj.children.length }} 个</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        unitObj: Object
    },
    data() {
        return {
            
        }
    },
    methods: {
        // 重置密码
        resetPassword() {
            this.$parent.resetPasswordAction(this.unitObj)
        },
        // 编辑施工单位
        editUnit() {
            this.$parent.editUnitAction(this.unitObj)
        },
        // 删除施工单位
        deleteUnit() {
            this.$parent.deleteUnitAction(this.unitObj)
        },
    },
}
</script>
<style scoped>
    .item {
        width: 100%;
        height: 100%;
    }
    .item .item-header {
        width: calc(100% - 32px);
        padding: 0 16px;
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
    }
    .item .item-header .item-header-number span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #777777;
        line-height: 20px;
    }
    .item .item-header .item-header-number button {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0054A0;
        line-height: 20px;
        margin-left: 18px;
    }
    .item .item-header .item-header-btn button img {
        width: 20px;
        height: 20px;
    }
    .item .item-header .item-header-btn .edit {
        margin-right: 16px;
    }
    /* 单位名称 */
    .item h4 {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181818;
        line-height: 25px;
        margin: 16px;
    }
    /* 下面数量统计 */
    .item .item-count {
        width: calc(100% - 32px);
        padding: 0 16px;
        display: flex;
        align-items: center;
    }
    .item .item-count div {
        display: flex;
        align-items: center;
    }
    .item .item-count div:first-child {
        margin-right: 36px;
    }
    .item .item-count div img {
        width: 18px;
        height: 18px;
        margin-right: 8px;
    }
    .item .item-count div span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #181818;
        line-height: 20px;
    }
</style>